var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScriptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45833 6.08333H8.625M4.45833 9H11.125M6.69479 14H12.125C13.5251 14 14.2252 14 14.76 13.7275C15.2304 13.4878 15.6128 13.1054 15.8525 12.635C16.125 12.1002 16.125 11.4001 16.125 10V5.5C16.125 4.09987 16.125 3.3998 15.8525 2.86502C15.6128 2.39462 15.2304 2.01217 14.76 1.77248C14.2252 1.5 13.5251 1.5 12.125 1.5H5.125C3.72487 1.5 3.0248 1.5 2.49002 1.77248C2.01962 2.01217 1.63717 2.39462 1.39748 2.86502C1.125 3.3998 1.125 4.09987 1.125 5.5V15.9463C1.125 16.3903 1.125 16.6123 1.21602 16.7263C1.29519 16.8255 1.41522 16.8832 1.54212 16.8831C1.68802 16.8829 1.86139 16.7442 2.20813 16.4668L4.19601 14.8765C4.6021 14.5517 4.80514 14.3892 5.03124 14.2737C5.23183 14.1712 5.44536 14.0963 5.66601 14.051C5.91472 14 6.17475 14 6.69479 14Z",
    stroke: "#525252",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScriptIcon);
export default __webpack_public_path__ + "static/media/scriptIcon.67f2221aed20a2ea28f54b047774dc62.svg";
export { ForwardRef as ReactComponent };